import { connect } from 'react-redux';
import {
  requestHotel,
  editHotel,
  editHotelFeatures,
  addHotelContact,
  removeHotelContact,
  addHotelPhoto,
  removeHotelPhoto,
  editHotelPhoto,
  sortHotelPhotos,
} from '../modules/hotels';

import HotelDetail from '../components/HotelDetail';

const mapDispatchToProps = {
  requestHotel,
  editHotel,
  editHotelFeatures,
  addHotelContact,
  removeHotelContact,
  addHotelPhoto,
  removeHotelPhoto,
  editHotelPhoto,
  sortHotelPhotos,
};

const mapStateToProps = (state, ownProps) => ({
  isFetching: state.hotels.selectedHotel.isFetching,
  needFetch: state.hotels.selectedHotel.needFetch,
  hasError: state.hotels.selectedHotel.hasError,
  hotel: state.hotels.selectedHotel.hotel,
  perms: state.auth.perms,
  id: ownProps.params.id,
  action: ownProps.params.action ? ownProps.params.action : 'view',
});

export default connect(mapStateToProps, mapDispatchToProps)(HotelDetail);



// WEBPACK FOOTER //
// src/routes/hotels/containers/HotelDetailContainer.js